export enum EventName {
    START_DAY = "Start Day",
    END_DAY = "End Day",
    TASK_PAGE_VIEW = "Task Page View",
    TASK_DETAIL_PAGE_VIEW = "Task Detail View",
    ENQUIRY_PAGE_VIEW = "Enquiry Page View",
    ENQUIRY_DETAIL_PAGE_VIEW = "Enquiry Detail View",
    LEAD_PAGE_VIEW = "Lead Page View",
    LEAD_DETAIL_PAGE_VIEW = "Lead Detail View",
}